/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ companyName: NonNullable<unknown> }} Lp_Login_Browsedescription1Inputs */

const en_lp_login_browsedescription1 = /** @type {(inputs: Lp_Login_Browsedescription1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Explore available ${i?.companyName} funds for future investments`)
};

/**
* | output |
* | --- |
* | "Explore available {companyName} funds for future investments" |
*
* @param {Lp_Login_Browsedescription1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const lp_login_browsedescription1 = /** @type {((inputs: Lp_Login_Browsedescription1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lp_Login_Browsedescription1Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_lp_login_browsedescription1(inputs)
});
export { lp_login_browsedescription1 as "lp_login_browseDescription" }